import { createNavigation } from 'next-intl/navigation';

export type Locale = string;

export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation({
    defaultLocale: 'en',
  });
